import * as React from 'react'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import MenuItem from '@mui/material/MenuItem'
import Box from '@mui/material/Box'
import { TextFieldProps } from '@mui/material/TextField'

import { Field } from 'formik'
import { MuiTextFieldFormik } from '@user/components/Formik'
import { useData, useHandlers } from '../hooks'
import { ConditionAttributeValue } from '../ConditionAttributeValue'
import type {
  ConditionModel,
  LeadAttribute,
} from '@user/components/Settings/LeadAssignmentRule/LeadAssignmentRuleForm/typings'

type Props = {
  textFieldProps: TextFieldProps
  setZipCodeValid: (value: boolean) => void
  assignmentRuleConditionsSelectedAttributes: LeadAttribute[]
  onDrawNewTerritory?: (condition: ConditionModel) => void
  onRedrawTerritory?: (condition: ConditionModel, territoryId: number) => void
}

export function ConditionFields(props: Props) {
  const {
    textFieldProps,
    setZipCodeValid,
    assignmentRuleConditionsSelectedAttributes,
    onDrawNewTerritory,
    onRedrawTerritory,
  } = props
  const { attributes, attribute, matches } = useData()
  const { handleAttributeChange } = useHandlers({})

  return (
    <Stack>
      <Stack direction="row" alignItems="start" mb={1.8}>
        <Typography variant="body1" whiteSpace="nowrap" mr={1} lineHeight={4.8}>
          If the
        </Typography>
        <Stack mr={2.1} width={333}>
          <Field
            name="attribute"
            label="Lead Attribute *"
            component={MuiTextFieldFormik}
            select
            size="medium"
            fullWidth
            onChange={handleAttributeChange}
            {...textFieldProps}
          >
            {attributes.map((attribute) => (
              <MenuItem
                key={attribute.id}
                value={attribute.id}
                disabled={assignmentRuleConditionsSelectedAttributes.includes(
                  attribute.id,
                )}
              >
                {attribute?.name}
              </MenuItem>
            ))}
          </Field>
        </Stack>
        <Box width={173} pb={0.6}>
          <Field
            name="matchType"
            label="Matches"
            component={MuiTextFieldFormik}
            select
            size="medium"
            fullWidth
            {...textFieldProps}
          >
            {matches.map((match) => (
              <MenuItem key={match.id} value={match.id}>
                {match?.name}
              </MenuItem>
            ))}
          </Field>
        </Box>
      </Stack>
      {!!attribute && (
        <Box>
          <ConditionAttributeValue
            setZipCodeValid={setZipCodeValid}
            onDrawNewTerritory={onDrawNewTerritory}
            onRedrawTerritory={onRedrawTerritory}
          />
        </Box>
      )}
    </Stack>
  )
}
